// extracted by mini-css-extract-plugin
export default {"light":"KXAK6D","dark":"DyB0We"};